<template>
    <div class="projectzb">
        <van-nav-bar :title="SGForm.title ? SGForm.title : SGForm.fname" @click-left="onClickLeft" left-arrow />
        <van-form @submit="onSubmit">
            <van-cell-group style="margin-bottom: 10px;">
                <van-cell title="问题标题：">
                    <template #default>
                        <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                            {{ SGForm.title ? SGForm.title : SGForm.fname }}
                        </div>
                    </template>
                </van-cell>
                <van-cell title="问题状态：">
                    <template #default>
                        <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                            {{ SGForm.strstatus }}
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
            <div v-for="(item, index) in  SGForm.disposelsit " :key="index">
                <van-cell-group style="margin-bottom: 10px;">
                    <van-cell :title="index == 0 ? '发起人：' : '追问人：'">
                        <template #default>
                            <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                {{ item.fbusername }}
                            </div>
                        </template>
                    </van-cell>
                    <van-cell :title="index == 0 ? '发起时间：' : '追问时间：'">
                        <template #default>
                            <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                {{ item.fbdate }}
                            </div>
                        </template>
                    </van-cell>
                    <van-field readonly label-class="classColor" type="textarea" label=" 问题描述:" v-model="item.fbcontent"
                        input-align="right" autosize />

                    <van-cell title="图片">
                        <template #default>
                            <div style="width: 100%;">
                                <van-swipe :autoplay="3000" :height="160" style="width: 100%;">
                                    <van-swipe-item v-for="file in item.fbfiles.split(',')" :key="file">
                                        <van-image contain style="width: 100%;height: 100%;" :src="actionUrl + file"
                                            @click="handClickIMG(actionUrl + file)" />
                                    </van-swipe-item>
                                </van-swipe>
                            </div>
                        </template>
                    </van-cell>
                </van-cell-group>
                <van-cell-group v-if="SGForm.creatuser == uid && replyUserAuthority">
                    <div
                        v-if="(!(index + 1 == SGForm.disposelsit.length && replyUserAuthority == false) || item.disposecontent != null) || (SGForm.creatuser == uid && replyUserAuthority)">
                        <van-cell title="处理人：">
                            <template #default>
                                <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                    {{ item.disusername }}
                                </div>
                            </template>
                        </van-cell>
                        <van-cell title="处理时间：">
                            <template #default>
                                <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                    {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                                </div>
                            </template>
                        </van-cell>
                    </div>
                    <div>
                        <van-field v-if="!questionDisable && index + 1 == SGForm.disposelsit.length" type="textarea"
                            label=" 处理情况:" v-model="item.disposecontent" input-align="right" autosize />
                        <van-field v-else readonly label-class="classColor" type="textarea" label=" 处理情况:"
                            v-model="item.disposecontent" input-align="right" autosize />
                        <!-- <van-cell v-else title="处理情况:" class="custom-cell">
                            <template #default class="custom-cell">
                                <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                    {{ item.disposecontent }}
                                </div>
                            </template>
                        </van-cell> -->
                    </div>
                    <van-cell title="图片">
                        <template #default>
                            <div style="width: 100%;">
                                <van-uploader ref="upload" v-if="item.disposefiles == null" v-model="fileList" multiple
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG" :after-read="afterRead" />
                                <van-swipe v-else :autoplay="3000" :height="160" style="width: 100%;">
                                    <van-swipe-item
                                        v-for=" (file1)  in (item.disposefiles != null ? item.disposefiles.split(',') : [])"
                                        :key="file1">
                                        <van-image contain style="width: 100%;height: 100%;" :src="actionUrl + file1"
                                            @click="handClickIMG(actionUrl + file1)" />
                                    </van-swipe-item>
                                </van-swipe>
                            </div>
                        </template>
                    </van-cell>
                    <div style="width: 90%; margin: 20px auto" v-if="submitStatus == false && index + 1 == SGForm.disposelsit.length
            ">
                        <van-button type="info" style="width: 100%; margin: auto" round
                            @click="questionBtn(item, false, index)">确定</van-button>
                    </div>
                    <div style="width: 90%; margin: 20px auto;display: flex;" v-if="replayStatus == true && index + 1 == SGForm.disposelsit.length
            ">
                        <van-button type="default" style="width: 40%; margin: auto" round v-show="zwStatus == true"
                            @click="continueBtn()">不合格</van-button>
                        <van-button type="info" style="width: 40%; margin: auto" round v-show="zwStatus == true"
                            @click="questionBtn(item, true, index)">关闭问题</van-button>
                    </div>
                </van-cell-group>
                <van-cell-group v-else>
                    <div
                        v-if="!(index + 1 == SGForm.disposelsit.length && replyUserAuthority == false) || item.disposecontent != null">
                        <div>
                            <van-cell title="处理人：">
                                <template #default>
                                    <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                        {{ item.disusername }}
                                    </div>
                                </template>
                            </van-cell>
                            <van-cell title="处理时间：">
                                <template #default>
                                    <div style="width: 100%;color: rgba(51, 51, 51, 0.8);">
                                        {{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}
                                    </div>
                                </template>
                            </van-cell>
                            <div>
                                <van-field
                                    v-if="(item.disposecontent == null ? true : !questionDisable) && index + 1 == SGForm.disposelsit.length"
                                    type="textarea" label=" 处理情况:" v-model="item.disposecontent" input-align="right"
                                    autosize />
                                <van-field label-class="classColor" v-else type="textarea" readonly label=" 处理情况:"
                                    v-model="item.disposecontent" input-align="right" autosize />
                            </div>
                            <van-cell title="图片">
                                <template #default>
                                    <div style="width: 100%;">
                                        <van-uploader ref="upload" v-if="item.disposefiles == null" v-model="fileList"
                                            multiple accept=".jpg,.jpeg,.png,.JPG,.JPEG" :after-read="afterRead" />
                                        <van-swipe v-else :autoplay="3000" :height="160" style="width: 100%;">
                                            <van-swipe-item
                                                v-for=" (file1)  in (item.disposefiles != null ? item.disposefiles.split(',') : [])"
                                                :key="file1">
                                                <van-image contain style="width: 100%;height: 100%;"
                                                    :src="actionUrl + file1" @click="handClickIMG(actionUrl + file1)" />
                                            </van-swipe-item>
                                        </van-swipe>
                                    </div>
                                </template>
                            </van-cell>
                            <div style="width: 90%; margin: 20px auto" v-if="item.disusername == null && index + 1 == SGForm.disposelsit.length
            ">
                                <van-button type="info" style="width: 100%; margin: auto" round
                                    @click="questionBtn(item, false, index)">确定</van-button>
                            </div>
                            <div style="width: 90%; margin: 20px auto;display: flex;"
                                v-if="SGForm.creatuser == uid && index + 1 == SGForm.disposelsit.length && replayStatus == true">

                                <van-button type="default" style="width: 40%; margin: auto" round
                                    v-show="zwStatus == true" @click="continueBtn()">不合格</van-button>
                                <van-button type="info" style="width: 40%; margin: auto" round v-show="zwStatus == true"
                                    @click="questionBtn(item, true, index)">关闭问题</van-button>
                            </div>
                        </div>
                    </div>
                </van-cell-group>

            </div>
            <div v-if="zwStatus == false">
                <van-cell-group style="margin-bottom: 10px;">
                    <van-field type="textarea" label="问题描述:" v-model="newFeedback.fbcontent" rows="2"
                        input-align="right" autosize />
                    <van-field label="图片:" style="align-items: center;" input-align="right">
                        <template #input>
                            <div style="width: 100%;height: 100px;">
                                <van-uploader ref="upload" v-model="fileList" multiple
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG" :after-read="afterRead" />
                            </div>
                        </template>
                    </van-field>
                    <div style="width: 90%; margin: 20px auto;">
                        <van-button type="info" style="width: 100%; margin: auto" round
                            @click="questionBtn1()">确定</van-button>
                    </div>
                </van-cell-group>
            </div>

        </van-form>
    </div>
</template>
<script>
import {
    YWFbAskedAndReply,
} from "@/api/index";
export default {
    name: "",
    data() {
        return {
            uid: Number(this.$store.state.uid),
            // 反馈
            SGForm: {},
            actionUrl: this.$store.state.baseUrl,
            questionDisable: false,
            replayStatus: false, //回复状态
            submitStatus: false, //确认状态
            zwStatus: true, //追问状态
            newFeedback: {},
            fileList: [],
            upOrdelUser: [],
            replyUser: [],
        }
    },
    computed: {
        replyUserAuthority() {
            return this.replyUser.includes(Number(this.$store.state.uid));
        },
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        },
        getData() {
            // //状态回复设置
            // if (this.SGForm.status === 0) {
            //     //
            //     this.replayStatus = false;
            //     this.questionDisable = false;
            //     this.submitStatus = false;
            // } else if (this.SGForm.status === 1) {
            //     //回复待确认
            //     this.replayStatus = true;
            //     this.questionDisable = true;
            //     this.submitStatus = true;
            //     this.zwStatus = true;
            // } else if (this.SGForm.status === 2) {
            //     //已关闭
            //     this.submitStatus = true;
            //     this.questionDisable = true;
            //     this.replayStatus = false;
            // }
            //状态回复设置
            if (this.SGForm.status === 0) {
                //
                this.replayStatus = false;
                this.questionDisable = false;
                this.submitStatus = false;
            } else if (this.SGForm.status === 1) {
                //回复待确认
                this.replayStatus = true;
                this.questionDisable = true;
                this.submitStatus = true;
                this.zwStatus = true;
            } else if (this.SGForm.status === 2) {
                //已关闭
                this.submitStatus = true;
                this.questionDisable = true;
                this.replayStatus = false;
            }
        },
        afterRead(v) {
            // this.fileList = v;
        },
        continueBtn(data) {
            this.newFeedback = {
                id: 0,
                feedbackid: this.SGForm.id,
                fbcontent: "",
            };
            this.zwStatus = false;
        },
        questionBtn(data, status, index) {
            // 设置回复人有权限
            // if (this.replyUser.includes(Number(this.$store.state.uid)) === true || this.SGForm.creatuser === Number(this.$store.state.uid)) {
            // if ((this.replyUser.includes(Number(this.$store.state.uid)) != true) || (this.SGForm.creatuser == (this.$store.state.uid)) != false) {
            //     this.$Notify({ type: "danger", message: "暂无权限" });
            // } else {
            let result = false;
            this.SGForm.disposelsit.forEach((el) => {
                if (el.disposecontent != null) {
                    // 上传地址
                    if (el.disposefiles != null || this.fileList.length > 0) {
                        result = true
                    } else {
                        this.$Notify({ type: "danger", message: "请填写完成数据!" });
                        result = false
                    }
                    // 都不为空
                    return result
                } else {
                    // 有空数据
                    this.$Notify({ type: "danger", message: "请填写完成数据!" });
                    result = false;
                }
                return result;
            });
            // result, true为不空,false为空
            if (result != false) {
                let params = {
                    fbid: this.SGForm.id,
                    projectid: this.$store.state.pid,
                    type: 3,
                    isclose: status,
                    disposeid: data.id,
                    strcontent: !status ? data.disposecontent : ''
                };
                let fd = new FormData();
                for (var key in params) {
                    fd.append(key, params[key]);
                }
                this.fileList.forEach((file) => {
                    fd.append("filses", file.file);
                });
                YWFbAskedAndReply(fd).then((res) => {
                    if (res.Code != 0) {
                        this.$Notify({ type: "success", message: "操作成功!" });
                        this.ShowQuestion = false;
                        this.replayStatus = true;
                        this.questionDisable = true;
                        this.fileList = [];
                        this.$router.go(-1);
                    } else {
                        this.$Notify({ type: "danger", message: "操作失败!" });
                    }
                });
            }
            // }
        },
        questionBtn1() {
            // 设置回复人有权限
            // if (this.replyUser.includes(Number(this.$store.state.uid)) != true) {
            //     this.$Notify({ type: "warning", message: "暂无权限" });
            // } else {
            if (this.fileList.length > 0 && this.newFeedback.fbcontent != "") {
                let params = {
                    fbid: this.newFeedback.feedbackid,
                    projectid: this.$store.state.pid,
                    type: 3,
                    isclose: false,
                    disposeid: 0,
                    strcontent: this.newFeedback.fbcontent,
                };
                let fd = new FormData();
                for (var key in params) {
                    fd.append(key, params[key]);
                }
                this.fileList.forEach((file) => {
                    fd.append("filses", file.file);
                });
                YWFbAskedAndReply(fd).then((res) => {
                    if (res.Code != 0) {
                        this.$Notify({ type: "success", message: "操作成功!" });
                        this.ShowQuestion = false;
                        this.zwStatus = true;
                        this.fileList = [];
                        this.$router.go(-1);
                        this.submitStatus = false;
                    } else {
                        this.$Notify({ type: "danger", message: "操作失败!" });
                    }
                });
            } else {
                this.$Notify({ type: "danger", message: "请填写完成数据!" });
            }

            // }
        },
        handClickIMG(val) {
            this.$ImagePreview({
                images: [val]
            })
        },
        onSubmit() { }
    },
    mounted() {
        this.upOrdelUser = this.$route.query.upOrdelUser;
        this.replyUser = this.$route.query.replyUser;
        this.SGForm = this.$route.query.item;
        console.log('this.SGForm: ', this.SGForm);
        this.getData()

    },
}
</script>
<style lang="scss" scoped>
.projectzb {
    background-color: #f5f5f5;
}

.classColor {
    color: #000
}
</style>
